import React from 'react';
import { Button, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { RTCTask } from 'core/models/rtc';

const Frame = styled.div({
    boxSizing: 'border-box',
    width: '778px',
    height: '240px',
    border: '1px solid #000000',
    background: '#9C9B9B',

    display: 'flex',
    justifyContent: 'space-evenly',
});

const Left = styled.div({
    width: '173px',
    height: '100%',
});

const Center = styled.div({
    width: '264px',
    height: '100%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const MainText = styled(Typography)({
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: '450',
    fontSize: '15px',
    lineHeight: '120%',
    /* identical to box height, or 18px */
    letterSpacing: '0.2em',
    color: '#FFFFFF',
});

const Right = styled.div({
    width: '173px',
    height: '100%',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

const AcceptButton = styled(Button)({
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: '450',
    fontSize: '15px',
    lineHeight: '120%',
    /* or 18px */
    textAlign: 'center',
    letterSpacing: '0.2em',
    textTransform: 'uppercase',
    color: '#00FFB1',
});

export type RTCControlPanelProps = {
    task?: RTCTask;
    onAccept: (task: RTCTask) => void;
}

export function RTCControlPanel(props: RTCControlPanelProps) {
    const { task, onAccept } = props;

    return (
        <Frame>
            <Left></Left>
            <Center>
                <MainText>{task?.taskType ?? 'No RTC'}</MainText>
            </Center>
            <Right>
                <AcceptButton disabled={!task} onClick={() => onAccept(task as RTCTask)}>{
                    task?.activated === true ? 'Deactivate' : 'Accept'
                }</AcceptButton>
            </Right>
        </Frame>
    );
}
